import React, { useMemo } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useBillingAccess } from '@/hooks/useBillingAccess';
import { toast } from 'sonner';

const restrictedPatterns: RegExp[] = [
  // All restrictions removed to allow unrestricted access
];

const BillingRouteGuard: React.FC = () => {
  const { locked, loading } = useBillingAccess();
  const location = useLocation();

  const isRestricted = useMemo(() => {
    const path = location.pathname;
    return restrictedPatterns.some(re => re.test(path));
  }, [location.pathname]);

  if (loading) return <Outlet />;

  if (locked && isRestricted) {
    toast.error('Billing issue: access restricted. Please update payment to resume all features.');
    return <Navigate to="/company-settings#billing" replace />;
  }

  return <Outlet />;
};

export default BillingRouteGuard;
